import { render } from "./SendApplicationEmail.vue?vue&type=template&id=50b2e793"
import script from "./SendApplicationEmail.vue?vue&type=script&lang=js"
export * from "./SendApplicationEmail.vue?vue&type=script&lang=js"
script.render = render

export default script